import moment from "moment";

/**
 * Next billing date from purchase/enrollment day (client anchor-day rule).
 * If the target month is shorter, use the last day of that month.
 */
export function getNextPaymentDate(purchaseDate, monthsAhead = 1) {
  const anchor = moment(purchaseDate);
  const anchorDay = anchor.date();
  const next = anchor.clone().add(monthsAhead, "months");
  const lastDayOfTargetMonth = next.clone().endOf("month").date();
  next.date(Math.min(anchorDay, lastDayOfTargetMonth));
  return next.startOf("day");
}

/**
 * Advance billing from a current due date while keeping the enrollment anchor day.
 * Used for cron / later cycles (e.g. Jan 31 → Feb 28 → Mar 31).
 */
export function advanceBillingDate(
  enrollmentDate,
  fromDate,
  periodsAhead = 1,
  unit = "month"
) {
  const anchorDay = moment(enrollmentDate).date();
  const next = moment(fromDate).add(periodsAhead, unit);
  const lastDay = next.clone().endOf("month").date();
  return next.date(Math.min(anchorDay, lastDay)).startOf("day");
}
